import { Link } from "react-router-dom";

interface CapabilityCardProps {
  title: string;
  description: string;
  icon: string;
  href: string;
  tags?: string[];
  featured?: boolean;
}

export default function CapabilityCard({ title, description, icon, href, tags, featured }: CapabilityCardProps) {
  return (
    <Link
      to={href}
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className={`card-base card-hover p-6 md:p-8 cursor-pointer group block ${featured ? "border-l-4 border-l-accent-500" : ""}`}
    >
      <div className="w-12 h-12 rounded-lg bg-primary-50 flex items-center justify-center mb-5 group-hover:bg-primary-100 transition-colors">
        <i className={`${icon} text-primary-600 text-xl`} aria-hidden="true"></i>
      </div>
      <h3 className="text-lg font-bold text-foreground-900 mb-2 group-hover:text-primary-700 transition-colors">
        {title}
      </h3>
      <p className="text-sm text-foreground-600 leading-relaxed mb-4">
        {description}
      </p>
      {tags && (
        <div className="flex flex-wrap gap-2">
          {tags.map((tag) => (
            <span key={tag} className="text-xs px-2.5 py-1 rounded-full bg-secondary-50 text-secondary-700 font-medium">
              {tag}
            </span>
          ))}
        </div>
      )}
      <span className="mt-5 flex items-center text-sm font-semibold text-primary-600 group-hover:text-primary-700 transition-colors">
        Learn more
        <i className="ri-arrow-right-line ml-1 group-hover:translate-x-1 transition-transform" aria-hidden="true"></i>
      </span>
    </Link>
  );
}